export function groupEventSponsors(sponsors, categoryOrder = []) {
    const groups = new Map(categoryOrder.map((category) => [category, []]));
    sponsors.forEach((sponsor) => {
        if (!groups.has(sponsor.category)) groups.set(sponsor.category, []);
        groups.get(sponsor.category).push(sponsor);
    });
    return [...groups].filter(([, items]) => items.length > 0)
        .map(([category, items]) => ({ category, sponsors: items }));
}

export function moveEventSponsor(groups, categoryIndex, sponsorIndex, direction) {
    const next = groups.map((group) => ({ ...group, sponsors: [...group.sponsors] }));
    const items = sponsorIndex === null ? next : next[categoryIndex]?.sponsors;
    const index = sponsorIndex === null ? categoryIndex : sponsorIndex;
    const target = index + direction;
    if (items && index >= 0 && index < items.length && target >= 0 && target < items.length) {
        [items[index], items[target]] = [items[target], items[index]];
    }
    return next.flatMap((group) => group.sponsors);
}
